import type { UrlOrganisation } from "components/entry/types";

import type { OrganisationsAction } from "../reducers/organisations";

const organisationsActions = {
  RECEIVE_URL_ORGANISATION: "RECEIVE_URL_ORGANISATION",
  SET_MOBILE_BANNER_OPEN: "SET_MOBILE_BANNER_OPEN",
  SET_DEMOING_TOUR: "SET_DEMOING_TOUR",
  HAS_SEEN_IDEA_LIKE_INFORMATION_MODAL_THIS_SESSION:
    "HAS_SEEN_IDEA_LIKE_INFORMATION_MODAL_THIS_SESSION",

  receiveUrlOrganisation(
    organisation: UrlOrganisation | null,
  ): OrganisationsAction {
    return { type: "RECEIVE_URL_ORGANISATION", organisation };
  },
  setMobileBannerOpen(open: boolean): OrganisationsAction {
    return { type: "SET_MOBILE_BANNER_OPEN", mobileBannerOpen: open };
  },
  setDemoingTour(tourId: string): OrganisationsAction {
    return { type: "SET_DEMOING_TOUR", tourId };
  },
  setHasSeenIdeaLikeInformationModalThisSession(
    hasSeen: boolean,
  ): OrganisationsAction {
    return {
      type: "HAS_SEEN_IDEA_LIKE_INFORMATION_MODAL_THIS_SESSION",
      hasSeen,
    };
  },
};

export default organisationsActions;
